










import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import EmailCampaignPreviewModal from './EmailCampaignPreviewModal.vue';

export default Vue.extend({
  props: {
    url: {
      type: String,
      required: true,
    },
    name: String,
  },
  methods: {
    open(): void {
      openModal(EmailCampaignPreviewModal, {
        url: this.url,
        label: (this.name) ? `${this.name} - Email Preview` : '',
      });
    },
  },
});
